import React from 'react';

// Hard isolation for the wallet-confirmation widget: any error (web3modal init, provider,
// render) is contained here and shown as a small fallback — it can never blank the profile page.
class WalletConfirmErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('WalletConfirm widget failed (contained):', error, info);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || null;
    }
    return this.props.children;
  }
}

export default WalletConfirmErrorBoundary;
